import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { NotifySettings } from '../api/types.js';
import { useApiClient } from './use-api-client.js';

// Notification delivery of a server (#760 step 3): what went out today, the digest schedule, per-type stats

export function useNotificationStats(serverId: string) {
  const api = useApiClient();
  return useQuery({ queryKey: ['notification-stats', serverId], queryFn: () => api.notifications.stats(serverId), refetchInterval: 300_000 });
}

export function useSaveNotifySettings(serverId: string) {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (settings: NotifySettings) => api.notifications.saveSettings(serverId, settings),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notification-stats', serverId] }),
  });
}

export function useRestoreKind(serverId: string) {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (kind: string) => api.notifications.restore(serverId, kind),
    onSuccess: (stats) => qc.setQueryData(['notification-stats', serverId], stats),
  });
}

/** « Notify everything » until a time, or off (null); the response says how many waiting decisions were sent */
export function useNotifyEverything(serverId: string) {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (until: string | null) => api.notifications.live(serverId, until),
    onSuccess: ({ flushed: _flushed, ...stats }) => qc.setQueryData(['notification-stats', serverId], stats),
  });
}
